export default (node) => {
  let modalEventListener = null;
  let modal = null;

  const handleClick = (e) => {
    const blockId = node.getAttribute('data-block-id');
    modal = document.querySelector(`[data-modal="${blockId}"]`);
    modal.classList.remove('hidden');

    modal.addEventListener('click', handleModalEvents);
  };

  const handleModalEvents = (e) => {
    const getClosest = e.target.closest('button');

    if (
      e.target.dataset.modal ||
      (getClosest && getClosest.dataset && getClosest.dataset.modalClose)
    ) {
      modal.classList.add('hidden');
      modal.removeEventListener('click', handleModalEvents);
    }
  };

  const init = () => {
    node.addEventListener('click', handleClick);
  };

  init();
};
